import React, { useState } from 'react';
import { MdLightbulbCircle } from "react-icons/md";
import { Link } from 'react-router-dom';
import { useApiContext } from '../context/ApiContext';

export default function Footer() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { api } = useApiContext();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const name = e.target.name.value.trim();
      const email = e.target.email.value.trim();
      const message = e.target.message.value.trim();

      if (!name || !email || !message) {
        alert('모든 필드를 입력해주세요.');
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        alert('유효한 이메일을 입력해주세요.');
        return;
      }

      const formData = { name, email, message };
      const webhookUrl = process.env.REACT_APP_WEBHOOK_URL;

      if (!webhookUrl) {
        throw new Error('문의 기능이 설정되지 않았습니다.');
      }

      const { error } = await api.sendContactMessage(webhookUrl, formData);

      if (error) {
        throw new Error(error.message || '메시지 전송에 실패했습니다.');
      }

      alert('메시지가 성공적으로 전송되었습니다.');
      e.target.reset();
    } catch (error) {
      alert(`메시지 전송에 실패했습니다: ${error.message}`);
    } finally {
      setIsModalOpen(false);
    }
  };

  return (
    <footer className='relative z-10 box-border py-8 px-6 md:py-12 md:px-10 bg-[#FFFEF6]'>
      <div className='max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-start'>      
        <div className='w-full md:w-auto mb-8 md:mb-0'>
          <h2 className='text-lg md:text-xl font-extrabold'>© 2025 Insight&Myung, LLC</h2>
          <p className='mt-2 text-sm md:text-base'>📨: jinhom6225@insightmyung.com</p>
        </div>

        <div className='w-full md:w-auto mb-8 md:mb-0 md:mx-12'>
          <h3 className='text-lg font-bold mb-3'>Legal</h3>
          <div className='flex flex-col space-y-2'>
            <Link to="/tos" className='hover:text-orange-300 transition-colors'>Terms of Service</Link>
            <Link to="/privacy" className='hover:text-orange-300 transition-colors'>Privacy Policy</Link>
          </div>
        </div>
        
        <div className='w-full md:w-auto flex justify-start md:justify-end'>
          <div className="relative group">
            <button 
              onClick={() => setIsModalOpen(true)}
              className="transition-all duration-300 hover:scale-110 hover:text-orange-300 cursor-pointer"
            >
              <MdLightbulbCircle size={36} className="md:w-12 md:h-12" />
            </button>
            <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-1 bg-gray-800 text-white text-sm rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap">
              문의사항
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-[#FFFEF6] p-4 rounded-lg w-full max-w-sm md:max-w-md">
            <h2 className="text-xl font-bold my-2">문의사항</h2>
            <form onSubmit={handleSubmit}>
              <div className="mb-2">
                <label className="block">이름</label>
                <input name="name" type="text" className="w-full border p-2 rounded bg-[#fffdee]" />
              </div>
              <div className="mb-2">
                <label className="block">이메일</label>
                <input name="email" type="email" className="w-full border p-2 rounded bg-[#fffdee]" />
              </div>
              <div className="mb-2">
                <label className="block">메시지</label>
                <textarea name="message" className="w-full border p-2 rounded h-24 bg-[#fffdee]" />
              </div>
              <div className="flex justify-end gap-2">
                <button 
                  type="button" 
                  onClick={() => setIsModalOpen(false)}
                  className="px-2 py-1 text-sm bg-gray-200 hover:bg-gray-300 text-gray-600 rounded"
                >
                  취소
                </button>
                <button 
                  type="submit"
                  className="px-2 py-1 text-sm bg-orange-300 hover:bg-orange-400 text-white rounded"
                >
                  전송
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </footer>
  );
}